import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

export interface LegendItem {
  key: string | number;
  label: string;
  color: string;
  count?: number; // opcional; no se renderiza
}

interface CalendarLegendProps {
  mode: "proyecto" | "estado";
  items: LegendItem[];
  title?: React.ReactNode;
  dense?: boolean;
}

export default function CalendarLegend({ mode, items, title, dense = false }: CalendarLegendProps) {
  const theme = useTheme();
  const { t } = useTranslation<"translation">();

  if (!items || items.length === 0) return null;

  const computedTitle =
    title ??
    (mode === "proyecto"
      ? t("calendar.legend.projects", "Proyectos")
      : t("calendar.legend.statuses", "Estados"));

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5,
        borderRadius: 1,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        {computedTitle}
      </Typography>

      <Stack direction="row" spacing={2} flexWrap="wrap">
        {items.map((it) => (
          <Stack
            key={String(it.key)}
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ mr: 2, mb: 1, minWidth: 120 }}
          >
            <Box
              sx={{
                width: dense ? 12 : 14,
                height: dense ? 12 : 14,
                borderRadius: 0.75,
                bgcolor: it.color,
                border: "1px solid rgba(0,0,0,0.25)",
                flex: "0 0 auto",
              }}
            />
            <Typography variant="body2" sx={{ lineHeight: 1.2 }}>
              {it.label}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Paper>
  );
}
